import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { runIndependentProductionTick } from './genericProduction';

export function runCharcoalTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    return runIndependentProductionTick(
        settlement,
        'charcoalPit',
        settlement.jobs.burners,
        settlement.production.charcoalPit.progress,
        config.production.charcoal.ticksPerBatch,
    );
}
